import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

const socket_server = axios.create({
    baseURL: process.env.REACT_APP_SOCKET_URL,
    headers: { 'Content-Type': 'application/json' }

})


export class ExcelModuleFechtAPI {

    //Function to upload Group
    static async UploadBusinessGroup(business_id, data, token) {
        const res = await server(`/excel/upload/products/${business_id}/business`, {
            method: "post",
            data: data,
            headers: { 'Content-Type': 'multipart/form-data', 'x-access-token': token },
        });
        return res
    }

    //Function to get template Group
    static async DownloadTemplateGroups(token) {
        try {
            const res = await server(`/excel/download/excel/product/template`, {
                method: "post",
                headers: {
                    "x-access-token": token,
                    "Content-Type": "application/json"
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "products_template.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el archivo", error);
            return false
        }
    }

        //Function to get template Group
    static async DownloadTemplateOptionals(token) {
        try {
            const res = await server(`/excel/download/optionals/template`, {
                method: "post",
                headers: {
                    "x-access-token": token,
                    "Content-Type": "application/json"
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "optionals_template.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el archivo", error);
            return false
        }
    }
    //Function to upload segments
    static async UploadBusinessSegments(business_id, data, token) {
        const res = await server(`/excel/upload/segments/${business_id}/business`, {
            method: "post",
            data: data,
            headers: { 'Content-Type': 'multipart/form-data', 'x-access-token': token },
        });
        return res
    }


    //Function to get template segment
    static async DownloadTemplateSegments(business_id) {
        const res = await server(`/excel/download/excel/segment/template`, {
            method: "get",
        });
        return res
    }



    //Function to upload item
    static async UploadBusinessItem(business_id, data, token) {
        const res = await server(`/excel/upload/items/${business_id}/business`, {
            method: "post",
            data: data,
            headers: { 'Content-Type': 'multipart/form-data', 'x-access-token': token },
        });
        return res
    }

    //Function to get template item
    static async DownloadTemplateItem(business_id) {
        const res = await server(`/excel/download/excel/item/template`, {
            method: "get",
        });
        return res
    }



    //Function to get template item
    static async downloadBankConsolidationReport(matched, unmatched, token) {
        try {
            const res = await server(`/excel/bank/consiliation`, {
                method: "post",
                data: {
                    matched,
                    unmatched
                },
                headers: {
                    "x-access-token": token,
                    "Content-Type": "application/json"
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "conciliacion.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el archivo", error);
            return false
        }
    }

    //Function to download the products template for PedidosYa
    static async downloadProductsPedidosYaTemplate(token, branchoffice_id) {
        try {
            const res = await server(`/excel/download/pedidosya/template/products?branchoffice_id=${branchoffice_id}`, {
                method: "post",
                headers: { 'x-access-token': token },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "products_pedidosya_template.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el template de PedidosYa", error);
            return false
        }
    }

    
    //Function to download the optionals template for PedidosYa
    static async downloadOptionalsPedidosYaTemplate(token, branchoffice_id) {
        try {
            const res = await server(`/excel/download/pedidosya/template/optionals?branchoffice_id=${branchoffice_id}`, {
                method: "post",
                headers: { 'x-access-token': token },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "optionals_pedidosya_template.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el template de PedidosYa", error);
            return false
        }
    }


    //Function to download the product sales report
    static async downloadProductSalesReport(token, initialDate, maxDate, branchoffice_id, business_id, event_id, branchoffices){
        try {
            const res = await server(`/excel/productsales/download`, {
                method: "post",
                headers: { 'x-access-token': token },
                data: {
                    firstDate: initialDate,
                    secondDate: maxDate,
                    branchoffice_id,
                    business_id,
                    machine_id: 0,
                    event_id,
                    branchoffices
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "sales_product_report.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el reporte ", error);
            return false
        } 
    }


    //Function to download the excel of the general sales 
    static async downloadGeneralSalesReport(token, initialDate, maxDate, selectedBranchId, machine_id, userBusinessId, userId, event_id){
        try {
            const res = await server(`/excel/generalsales/download`, {
                method: "post",
                headers: { 'x-access-token': token },
                data: {
                    firstDate: initialDate,
                    secondDate: maxDate,
                    branchoffice_id: selectedBranchId,
                    machine_id: machine_id ? machine_id : 0,
                    business_id: userBusinessId,    
                    user_id: userId, 
                    event_id: event_id ? event_id : 0
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });
            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "general_sales_report.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el reporte ", error);
            return false
        }
    }


    
    //Function to download the excel of the payment method report 
    static async downloadPayMethodSalesReport(token, initialDate, maxDate, selectedBranchId, machine_id, userBusinessId, event_id){
        try {
            const res = await server(`/excel/paymentmethodsales/download`, {
                method: "post",
                headers: { 'x-access-token': token },
                data: {
                    firstDate: initialDate,
                    secondDate: maxDate,
                    branchoffice_id: selectedBranchId,
                    machine_id: machine_id ? machine_id : 0,
                    business_id: userBusinessId, 
                    event_id: event_id ? event_id : 0
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });
            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "payment_method_sales_report.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el reporte ", error);
            return false
        }
    }


    //Function to download the excel of the approved refunds report
    static async downloadRefundReport(token, initialDate, maxDate, branchoffice_id, business_id) {
        try {
            const res = await server(`/excel/refund/download`, {
                method: "post",
                headers: { 'x-access-token': token },
                data: {
                    firstDate: initialDate,
                    secondDate: maxDate,
                    branchoffice_id,
                    business_id
                },
                responseType: "blob" // Asegúrate de recibir la respuesta como un blob (archivo)
            });
            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "refund_report.xlsx"); // El nombre del archivo a descargar
            document.body.appendChild(link);
            link.click();
            return true
        } catch (error) {
            console.error("Error descargando el reporte ", error);
            return false
        }
    }


}